/**
 * TrayPopoverLayout - Minimal layout for the macOS menu bar tray popover
 *
 * This layout provides:
 * - No sidebar or header
 * - Minimal providers needed for tasks/time tracking
 * - Clean, focused UI for the popover
 */

import { useAuth } from '@/components/auth/AuthProvider'
import { RecorderController } from '@/components/desktop/RecorderController'
import { Skeleton } from '@/components/ui/skeleton'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { isTauri } from '@/lib/utils/tauri'
import { Outlet } from 'react-router-dom'

export function TrayPopoverLayout() {
  const { isAuthenticated, isLoading } = useAuth()
  const { checkFeatureFlag } = useFeatureFlags()

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-background">
        <div className="w-full max-w-sm space-y-3 p-4">
          <Skeleton className="h-8 w-32" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-24 w-full" />
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-background p-4">
        <div className="text-center">
          <p className="text-sm text-muted-foreground">
            Sign in to view your tasks
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      {isTauri() && checkFeatureFlag('MEETING_NOTES') && <RecorderController />}
      <Outlet />
    </div>
  )
}
